import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/home'
import index from '@/pages/index/index'
import Login from '@/pages/login/login'
import Financial from '@/pages/financial/financial'
import Information from '@/pages/information/information'
import System from '@/pages/system/system'
// 商户中心
import Merchants from '@/pages/merchants/merchants'
import BusinessInformation from '@/pages/merchants/client/businessInformation'
import ContractInformation from '@/pages/merchants/client/contractInformation'
import LookUpInformation from '@/pages/merchants/client/lookUpInformation'
import AddressInformation from '@/pages/merchants/client/addressInformation'
// 交易中心
import Trading from '@/pages/trading/trading'
import OrderInformation from '@/pages/trading/order/orderInformation'
import OrdersAll from '@/pages/trading/order/ordersAll'
import UserInformation from '@/pages/trading/soho/userInformation'
import UserAll from '@/pages/trading/soho/userAll'
import UsersSignUp from '@/pages/trading/soho/usersSignUp'
import InvoiceApplyFor from '@/pages/trading/invoice/invoiceApplyFor'
import InvoiceManagement from '@/pages/trading/invoice/invoiceManagement'
import InvoicesAll from '@/pages/trading/invoice/invoicesAll'
import InvoiceTransact from '@/pages/trading/invoice/invoiceTransact'
import RedDashedApply from '@/pages/trading/invoice/redDashedApply'
import RedDashedTransact from '@/pages/trading/invoice/redDashedTransact'
// 财务中心
import TopUpApplication from '@/pages/financial/money/topUpApplication'
import CashTransactions from '@/pages/financial/money/cashTransactions'
import CapitalFlows from '@/pages/financial/money/capitalFlows'
import CapitalAccount from '@/pages/financial/money/capitalAccount'
// 系统中心
import BusinessScope from '@/pages/system/maintenance/businessScope'
import Delivery from '@/pages/system/maintenance/delivery'
import InvoiceContent from '@/pages/system/maintenance/invoiceContent'
import Registered from '@/pages/system/maintenance/registered'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: {
        requireAuth: true // 配置此条，进入页面前判断是否需要登陆
      },
      component: Home
    },
    {
      path: '/index',
      name: 'index',
      meta: {
        requireAuth: true // 配置此条，进入页面前判断是否需要登陆
      },
      component: index
    },
    {
      path: '/financial',
      name: 'Financial',
      component: Financial,
      meta: {
        title: '财务中心',
        requireAuth: true // 配置此条，进入页面前判断是否需要登陆
      },
      redirect: '/financial/capitalAccount', // 默认进入
      children: [
        {
          path: '/financial/cashTransactions',
          name: 'cashTransactions',
          component: CashTransactions
        },
        {
          path: '/financial/capitalFlows',
          name: 'capitalFlows',
          component: CapitalFlows
        },
        {
          path: '/financial/capitalAccount',
          name: 'capitalAccount',
          component: CapitalAccount
        },
        {
          path: '/financial/topUpApplication',
          name: 'topUpApplication',
          component: TopUpApplication
        }
      ]
    },
    {
      path: '/information',
      name: 'Information',
      meta: {
        title: '数据中心',
        activeMenu: '/information',
        requireAuth: true // 配置此条，进入页面前判断是否需要登陆
      },
      component: Information
    },
    {
      path: '/merchants',
      name: 'Merchants',
      meta: {
        title: '商户中心',
        requireAuth: true // 配置此条，进入页面前判断是否需要登陆
      },
      redirect: '/merchants/businessInformation',
      component: Merchants,
      children: [
        {
          path: '/merchants/businessInformation',
          name: 'BusinessInformation',
          component: BusinessInformation
        },
        {
          path: '/merchants/contractInformation',
          name: 'ContractInformation',
          component: ContractInformation
        },
        {
          path: '/merchants/lookUpInformation',
          name: 'LookUpInformation',
          component: LookUpInformation
        },
        {
          path: '/merchants/addressInformation',
          name: 'AddressInformation',
          component: AddressInformation
        }
      ]
    },
    {
      path: '/system',
      name: 'System',
      meta: {
        title: '系统中心',
        activeMenu: '/system',
        requireAuth: true // 配置此条，进入页面前判断是否需要登陆
      },
      redirect: '/system/registered',
      component: System,
      children: [
        {
          path: '/system/businessScope',
          name: 'businessScope',
          component: BusinessScope
        },
        {
          path: '/system/delivery',
          name: 'delivery',
          component: Delivery
        },
        {
          path: '/system/invoiceContent',
          name: 'invoiceContent',
          component: InvoiceContent
        },
        {
          path: '/system/registered',
          name: 'registered',
          component: Registered
        }
      ]
    },
    {
      path: '/trading',
      name: 'Trading',
      meta: {
        title: '业务中心',
        requireAuth: true // 配置此条，进入页面前判断是否需要登陆
      },
      redirect: '/trading/ordersAll',
      component: Trading,
      children: [
        {
          path: '/trading/invoiceApplyFor',
          name: 'invoiceApplyFor',
          component: InvoiceApplyFor
        },
        {
          path: '/trading/invoiceManagement',
          name: 'invoiceManagement',
          component: InvoiceManagement
        },
        {
          path: '/trading/invoicesAll',
          name: 'invoicesAll',
          component: InvoicesAll
        },
        {
          path: '/trading/invoiceTransact',
          name: 'invoiceTransact',
          component: InvoiceTransact
        },
        {
          path: '/trading/redDashedApply',
          name: 'redDashedApply',
          component: RedDashedApply
        },
        {
          path: '/trading/redDashedTransact',
          name: 'redDashedTransact',
          component: RedDashedTransact
        },
        {
          path: '/trading/userAll',
          name: 'UserAll',
          component: UserAll
        },
        {
          path: '/trading/userInformation',
          name: 'UserInformation',
          component: UserInformation
        },
        {
          path: '/trading/usersSignUp',
          name: 'UsersSignUp',
          component: UsersSignUp
        },
        {
          path: '/trading/orderInformation',
          name: 'orderInformation',
          component: OrderInformation
        },
        {
          path: '/trading/ordersAll',
          name: 'ordersAll',
          component: OrdersAll
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    }
  ]
})

// const whiteList = ['/login'] // 免登录白名单

// Router.beforeEach((to, from, next) => {
//   if (cookieGetToken()) { // determine if there has token
//     /* has token*/
//     if (to.path === '/login') {
//       next({ path: '/' })
//     }
//     next()
//   } else {
//     /* has no token*/
//     if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
//       next()
//     } else {
//       next('/login') // 否则全部重定向到登录页
//     }
//   }
// })



// WEBPACK FOOTER //
// ./src/router/index.js